import { render, staticRenderFns } from "./ClientCommentBlock.vue?vue&type=template&id=f12e3ba2"
import script from "./ClientCommentBlock.vue?vue&type=script&lang=js"
export * from "./ClientCommentBlock.vue?vue&type=script&lang=js"
import style0 from "./ClientCommentBlock.vue?vue&type=style&index=0&id=f12e3ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports